import React  from 'react'
import ReactTooltip from 'react-tooltip';
import Auth from "../Pages/Auth/Auth"
import Footer from "./Footer/Footer"
import Header from "./Header/Header"
import Index from "../Pages/Index/Index"
import Event from "../Pages/Event/Event"
import History from "../Pages/History/History"
import Main from "../Pages/Main/Main"
import Search from "../Pages/Search/Search"
import NotFound from "../Pages/NotFound/NotFound"
import Windows from "../Modal/Windows"
import Tour from "../Components/Tour/Tour"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { UserContext } from "../../context"
import { AUTH_LOGIN } from "../../constant"
import css from './Layout.module.scss'


export default function Layout (){
	const { user } = React.useContext(UserContext)

	return(
		<Router>
			<div className={css.app}>
				{(user?.auth === AUTH_LOGIN && user?.categories)
					? <>
						<Header/>
						<main className={css.layout + ' ' + css.flex}>
							<Switch>
								<Route exact path="/" component={Index}/>
								<Route exact path="/search" component={Search}/>
								<Route exact path="/event/:eventId" component= {Event}/>
								<Route exact path="/history" component={History}/>
								<Route exact path="/main" component={Main}/>
								<Route path="*" component={NotFound}/>
							</Switch>
						</main>
						<Footer/>
					</>
					: <Auth/>
				}
				<Windows/>
				<ReactTooltip/>
				<Tour/>
			</div>
		</Router>
	)
}